const germanDates_ = {
    monday: 'Montag',
    tuesday: 'Dienstag',
    wednesday: 'Mittwoch',
    thursday: 'Donnerstag',
    friday: 'Freitag',
    saturday: 'Samstag',
    sunday: 'Sonntag'
}

const germanMonths = {
    january: 'Januar',
    february: 'Februar',
    march: 'März',
    april: 'April',
    may: 'Mai',
    june: 'Juni',
    july: 'Juli',
    august: 'August',
    september: 'September',
    october: 'Oktober',
    november: 'November',
    december: 'Dezember'
}

function getGermanDate(date) {
    if (date == 'Mon') {
        date = germanDates_.monday
    }
    else if (date == 'Tue') {
        date = germanDates_.tuesday
    }
    else if (date == 'Wed') {
        date = germanDates_.wednesday
    }
    else if (date == 'Thu') {
        date = germanDates_.thursday
    }
    else if (date == 'Fri') {
        date = germanDates_.friday
    }
    else if (date == 'Sat') {
        date = germanDates_.saturday
    }
    else if (date == 'Sun') {
        date = germanDates_.sunday
    }
    return date
}

function getGermanMonth(date) {
    if (date == 'Jan') {
        date = germanMonths.january
    }
    else if (date == 'Feb') {
        date = germanMonths.february
    }
    else if (date == 'Mar') {
        date = germanMonths.march
    }
    else if (date == 'Apr') {
        date = germanMonths.april
    }
    else if (date == 'May') {
        date = germanMonths.may
    }
    else if (date == 'Jun') {
        date = germanMonths.june
    }
    else if (date == 'Jul') {
        date = germanMonths.july
    }
    else if (date == 'Aug') {
        date = germanMonths.august
    }
    else if (date == 'Sep') {
        date = germanMonths.september
    }
    else if (date == 'Oct') {
        date = germanMonths.october
    }
    else if (date == 'Nov') {
        date = germanMonths.november
    }
    else if (date == 'Dec') {
        date = germanMonths.december
    }
    return date
}

// 22.10.2026: Satz und Datum in der Sprache der Seite. Der Satz kommt aus dem Theme (data-satz, i18n/fl_ral.<sprache>.json
//    kauf.ruecksendung_bis), das Datum (heute + 30 Tage) formatiert der Browser in der Seitensprache. Fehlt data-satz, bleibt der deutsche Satz.
function ruecksendungSetzen () {
    const el = document.getElementById("return-policy")
    if (!el) return
    // 28.10.2026: Fester Satz statt Datum auf Domains, deren Merchant-Konto wegen Falschdarstellung gesperrt ist (wie FL, Finn). Andere Hosts: Datum wie bisher.
    const fest = ({ dk: "30 dages returret fra modtagelse af varen" })[location.hostname.split(".").pop()]
    if (fest) { el.textContent = fest; return }
    const bis = new Date(); bis.setDate(bis.getDate() + 30)
    const satz = el.getAttribute("data-satz")
    if (!satz || satz.indexOf("{datum}") < 0) { el.innerHTML = `Rücksendung bis ${getGermanDate(currentDateArr[0].replace(',', ''))}, ${currentDateArr[1]} ${getGermanMonth(currentDateArr[2])} möglich`; return }
    let datum
    try { datum = new Intl.DateTimeFormat(document.documentElement.lang || "de", { weekday: "long", day: "numeric", month: "long" }).format(bis) } catch (_) { datum = bis.toLocaleDateString() }
    el.textContent = satz.replace("{datum}", datum)
}

const currentDate = new Date();
currentDate.setDate(currentDate.getDate() + 30)
const currentDateArr = currentDate.toUTCString().split(" ").slice(0, 3);

// Seit 27.10.2026: Beide Zweige des frueheren Weckers (vor und nach 13 Uhr) riefen nur ruecksendungSetzen();
// die Reste der Versandzeit-Anzeige rechneten Werte aus, die nichts mehr anzeigten, und sind weg.
setTimeout(ruecksendungSetzen, 1000);
